import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { BaseHubConnection } from './base-hub-connection.service';
import { GlobalVariablesService } from '../global-variables.service';

export interface NotificationRealtimeMessage {
    eventId?: string;
    userNotificationId?: string;
    unread?: number;
    batchCount?: number;
    topic?: string;
    severity?: string;
    createdAtUtc?: string;
    muted?: boolean;
}

@Injectable({
    providedIn: 'root'
})
export class NotificationHubConnectionService extends BaseHubConnection {
    private initialized = false;
    private newNotificationSubject = new Subject<NotificationRealtimeMessage>();

    public newNotification$ = this.newNotificationSubject.asObservable();

    constructor(private globals: GlobalVariablesService) {
        super();
    }

    public init(): void {
        if (this.initialized) {
            void this.startConnection();
            return;
        }

        this.initializeHubConnection(`${this.globals.apiV2Address}/notification-hub`, { withCredentials: false });

        if (!this.hubConnection) {
            return;
        }

        this.hubConnection.on('notification:new', (message: NotificationRealtimeMessage) => {
            this.newNotificationSubject.next(message ?? {});
        });

        this.initialized = true;
        void this.startConnection();
    }
}
